<template>
    <div class="p-3 mb-4 rounded-lg" :class="notificationTypeClass">
        <p class="font-weight-bold d-flex align-items-center">
            <span class="d-flex flex-wrap align-items-center">
                <span class="field-steps bg-white rounded-lg me-1">
                    <font-awesome-icon class="icon-error text-danger" icon="times" v-if="notificationTypeClass === 'error'"/>
                    <font-awesome-icon class="check-icon text-success" icon="check" v-if="notificationTypeClass === 'success' "/>
                </span>

                {{ notification.message }}
                {{ notification.location }}
                <span>{{ extraNotificationInfo }}</span>
                <a href="#" class="retry-link" v-if="notificationSendingType===0" @click="retry">{{ text.retry }}</a>
                <a href="#" class="retry-link" v-if="notification.localisation" @click="retryloc">{{ text.retry }}</a>
            </span>
        </p>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
    props: {
        notification: {
            type: String,
            required: true
        },
        appointement: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            timeout: null,
            text: {
                retry: ' ' + Drupal.t('Retry')
            }
        }
    },
    mounted () {
        if (this.notification.id > 1) {
            let toRomveNotifcation = this.notification.id - 1
            this.remove(toRomveNotifcation)
        }
        if (this.notification !== undefined && this.notification.type !== 'success') {
            if (this.notification.sending) {
                let url = '/errors/' + this.notification.sending.type
                // Google Tag-Manager push 'virtualPageView' to dataLayer
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: `virtual_page_view`,
                        event_type: ``,
                        event_data: {
                            path: url
                        }
                    })
                }
            }
        }

        /* this.timeout = setTimeout(() => {
            // start a timeout on mounted
            // call the remove action, send in this.notification
            this.remove(this.notification.id)
        }, 20000) */
    },
    beforeDestroy () {
        clearTimeout(this.timeout)
    },
    computed: {
        notificationTypeClass () {
            return this.notification.type // return -text-error or -text-success
        },
        notificationSendingType () {
            if (this.notification.sending !== undefined) {
                if (this.notification.sending.type === 'timeout') {
                    if (this.notification.sending._step_id === undefined) {
                        return 1
                    } else if (this.notification.sending._step_id === 4) {
                        return 1
                    }
                    return 0
                } else {
                    return 1
                }
            }
            return -1
        },
        extraNotificationInfo () {
            if (this.notificationSendingType !== -1) {
                if (this.notificationSendingType === 0) {
                    return ' ' + Drupal.t('Please click the link to try again.')
                } else if (this.notificationSendingType === 1) {
                    return ' ' + Drupal.t('Please try again later.')
                }
            }
            return ''
        },
        ...mapGetters('notification', ['getRetryCount']),
        ...mapGetters('etermin', ['getActiveStep']),
        ...mapState([
            'loading',
            'selectedStore'
        ])
    },
    methods: {
        retry (event) {
            if(this.getRetryCount()<10){
                event.preventDefault()
                this.appointement.end = null
                this.$store.dispatch('notification/clear', null, {
                    root: true
                })
                this.appointement.start = null
                this.appointement.end = null
                if (this.getActiveStep === 0 || (this.getActiveStep - 1) === 0) {
                    this.$store.dispatch('etermin/fetchServices', {store: this.selectedStore})
                }
                this.$store.dispatch('etermin/updateSteps', this.getActiveStep === 0 ? 0 : (this.getActiveStep - 1))
                this.incrementCount()
            }
            else{
               window.location.reload()
            }
        },
        retryloc (event) {
            event.preventDefault()
            let href = window.location.href
            if (href.includes('?mein=1')){
                window.location.reload()
            }
            else{
                window.location.href = window.location.href +'?mein=1'
            }
        },
        ...mapActions('notification', ['incrementCount']),
        ...mapActions('notification', ['remove'])
    }
}
</script>

<style lang="scss" scoped>

</style>
